// extracted by mini-css-extract-plugin
export default {"visualSheduleTooltip":"VisualSheduleTooltip_visualSheduleTooltip__9GaVW","visualSheduleTooltip__text":"VisualSheduleTooltip_visualSheduleTooltip__text__KFPEP"};